import type { ISunlabCaseDefinition } from "./ICaseDefinition/ISunlabCaseDefinition";

/**
 * Human-readable Sunlabs `Type` → short product line label (legacy CaseConfApi).
 * Known types map to a label; other non-empty strings fall back to `type.toLowerCase()`.
 * Missing/invalid `Type` or dimensions: {@link getCaseConfDisplayModelFromSunlab} returns `undefined`.
 */
export const CASE_CONF_TYPE_DISPLAY_LABELS: Record<string, string> = {
  KEYBOARDCASE_SPECIAL: "Keyboard-Case Spez.",
  KEYBOARDCASE_TYPE: "Keyboard-Case",
  LID_ECONOMY: "Haube Eco",
  LID_HEAVY: "Haube Heavy",
  LID_LIVE: "Haube Live",
  LID_PROFESSIONAL: "Haube Profi",
  RACK_DOUBLE_DOOR_ECONOMY: "DD Rack Eco",
  RACK_DOUBLE_DOOR_LIVE: "DD Rack Live",
  RACK_DOUBLE_DOOR_PROFESSIONAL: "DD Rack Profi",
  SUITCASE_ECONOMY: "Koffer Eco",
  SUITCASE_HEAVY: "Koffer Heavy",
  SUITCASE_LIVE: "Koffer Live",
  SUITCASE_PROFESSIONAL: "Koffer Profi",
  TRUNK_ECONOMY: "Truhe Eco",
  TRUNK_HEAVY: "Truhe Heavy",
  TRUNK_LIVE: "Truhe Live",
  TRUNK_PROFESSIONAL: "Truhe Profi",
};

/**
 * Position `model` string from Sunlabs case JSON (same formula as legacy `CaseConfApi.fetchOrderFromCaseConf`).
 * Malformed payloads (missing/invalid `Type` or dimensions) return `undefined` instead of throwing.
 */
export function getCaseConfDisplayModelFromSunlab(
  def:
    | Pick<ISunlabCaseDefinition, "Type" | "Width" | "Depth" | "Height">
    | null
    | undefined,
): string | undefined {
  if (!def) return undefined;
  const typeRaw = def.Type;
  if (typeof typeRaw !== "string" || typeRaw.trim() === "") {
    return undefined;
  }
  const typeKey = typeRaw.trim();
  const line = CASE_CONF_TYPE_DISPLAY_LABELS[typeKey] ?? typeKey.toLowerCase();
  const { Width: w, Depth: d, Height: h } = def;
  if (
    typeof w !== "number" ||
    typeof d !== "number" ||
    typeof h !== "number" ||
    !Number.isFinite(w) ||
    !Number.isFinite(d) ||
    !Number.isFinite(h)
  ) {
    return undefined;
  }
  return `${line} ${w}x${d}x${h}`;
}
